import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IUser } from '../../types/redux/user';

export enum EActionTypes {
  SET_USER_DATA = 'user/SetUserData',
}

/** anonymousUserId проставляется на стороне node */
type TSetUserDataPayload = Omit<IUser, 'anonymousUserId'>;

export const setUserData = actionGenerator<EActionTypes.SET_USER_DATA, TSetUserDataPayload>(EActionTypes.SET_USER_DATA);

export type TUserActions = ReturnType<typeof setUserData>;
